import { render, staticRenderFns } from "./order-manage.vue?vue&type=template&id=9c854156&scoped=true&"
import script from "./order-manage.vue?vue&type=script&lang=js&"
export * from "./order-manage.vue?vue&type=script&lang=js&"
import style0 from "./order-manage.vue?vue&type=style&index=0&id=9c854156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c854156",
  null
  
)

export default component.exports